import React, { useState, useEffect } from "react";
import "./dropdown.css";
import "clarity-ui/clarity-ui.min.css";
import "@webcomponents/custom-elements/custom-elements.min.js";
import "@clr/icons/clr-icons.min.css";
import "@clr/icons/shapes/all-shapes.js";
import "@cds/core/icon/shapes/arrow.js";
import "clarity-icons/clarity-icons.min.css";
import { ClarityIcons, arrowIcon } from "@cds/core/icon";
import { useAuth0 } from "@auth0/auth0-react";
import { Link } from "react-router-dom";
import axios from 'axios';

import "@cds/core/dropdown/register.js";
import "@cds/core/button/register.js";
import "@cds/core/divider/register.js";

ClarityIcons.addIcons(arrowIcon);

function Dropdown_3() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [sharedFolders, setSharedFolders] = useState([]);
  const [expandedFolders, setExpandedFolders] = useState({});
  const { user, getAccessTokenSilently, isAuthenticated } = useAuth0();

  const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
  });

  const handleDropdownToggle = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleDropdownClose = () => {
    setIsDropdownOpen(false);
  };

  const toggleFolder = (folderId) => {
    setExpandedFolders(prev => ({
      ...prev,
      [folderId]: !prev[folderId]
    }));
  };

  const getSharedFoldersForCategory = (category, workpackage = null) => {
    const filtered = sharedFolders.filter(folder => {
      if (workpackage) {
        return folder.workpackage === workpackage;
      }
      switch (category) {
        case 'deliverables':
          return folder.is_deliverable;
        case 'meetings':
          return folder.is_meeting;
        case 'promotion':
          return folder.is_promotion;
        case 'reports':
          return folder.is_report;
        case 'publications':
          return folder.is_publication;
        case 'templates':
          return folder.is_template;
        case 'contactlists':
          return folder.is_contact_list;
        default:
          return false;
      }
    });
    
    
    return filtered;
  };

  const renderMenuItemWithSharedFolders = (to, label, category, workpackage = null, disabled = false) => {
    const categorySharedFolders = getSharedFoldersForCategory(category, workpackage);
    const hasSharedFolders = categorySharedFolders.length > 0;
    const menuKey = `menu-${category}-${workpackage || ''}`;
    
    const handleMainItemClick = (e) => {
      if (hasSharedFolders) {
        e.preventDefault();
        toggleFolder(menuKey);
      }
    };
    
    return (
      <div key={menuKey}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          {hasSharedFolders ? (
            <div
              className={`dropdown-item ${disabled ? "disabled" : ""}`}
              onClick={handleMainItemClick}
              style={{ 
                flex: 1, 
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
            >
              <span>{label}</span>
              <clr-icon 
                shape="arrow" 
                dir={expandedFolders[menuKey] ? "up" : "down"}
                style={{ fontSize: '12px' }}
              ></clr-icon>
            </div>
          ) : (
            <Link
              to={to}
              className={`dropdown-item ${disabled ? "disabled" : ""}`}
              style={{ flex: 1 }}
            >
              {label}
            </Link>
          )}
        </div>
        {hasSharedFolders && expandedFolders[menuKey] && (
          <div style={{ paddingLeft: '20px', marginTop: '5px' }}>
            <Link
              to={to}
              className={`dropdown-item ${disabled ? "disabled" : ""}`}
              style={{ 
                fontSize: '0.9em',
                fontStyle: 'italic',
                color: '#007cbb',
                borderBottom: '1px solid #e9ecef',
                marginBottom: '5px'
              }}
            >
              → View {label} Page
            </Link>
            {renderFolderWithSubfolders(categorySharedFolders, 0)}
          </div>
        )}
      </div>
    );
  };

  const handleFileClick = (file, fileName) => {
    const userChoice = window.confirm(`Would you like to download "${fileName}"? Click OK to download or Cancel to view.`);
    
    if (userChoice) {
      // Force download using fetch to bypass browser's default behavior
      fetch(file.file_url)
        .then(response => response.blob())
        .then(blob => {
          const link = document.createElement('a');
          const url = window.URL.createObjectURL(blob);
          link.href = url;
          link.download = fileName; // Use the cleaned filename
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch(error => {
          console.error('Download failed:', error);
          // Fallback to direct link if fetch fails
          const link = document.createElement('a');
          link.href = file.file_url;
          link.download = fileName;
          link.setAttribute('target', '_blank');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        });
    } else {
      // View the file (open in new tab using direct S3 URL)
      window.open(file.file_url, '_blank');
    }
  };

  const handleDownloadFolder = (folder) => {
    // Create download link for folder
    const link = document.createElement('a');
    link.href = `/api/download-folder/${folder.id}`;
    link.download = `${folder.folder_name}.zip`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const renderFolderWithSubfolders = (folders, indentLevel = 0) => {
    return folders.map(folder => (
      <div key={folder.id} className="shared-folder-container" style={{ paddingLeft: `${indentLevel}px` }}>
        <div 
          className="dropdown-item folder-item"
          onClick={() => toggleFolder(folder.id)}
          style={{ 
            cursor: 'pointer', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'space-between',
            fontSize: '0.9em',
            color: '#555',
            backgroundColor: indentLevel > 0 ? 'rgba(248, 249, 250, 0.8)' : '#f8f9fa',
            border: '1px solid #e9ecef',
            borderRadius: '3px',
            margin: '2px 0'
          }}
        >
          <span>📁 {folder.folder_name}</span>
          <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            {/* Download button for folder */}
            <span 
              onClick={(e) => { e.stopPropagation(); handleDownloadFolder(folder); }}
              style={{ cursor: 'pointer', fontSize: '0.8em', color: '#007cbb' }}
              title="Download folder"
            >
              ⬇️
            </span>
            <clr-icon 
              shape="arrow" 
              dir={expandedFolders[folder.id] ? "up" : "down"}
              style={{ fontSize: '10px' }}
            />
          </div>
        </div>
        
        {expandedFolders[folder.id] && (
          <div className="folder-contents" style={{ paddingLeft: '15px', marginTop: '2px' }}>
            {/* Render files in this folder */}
            {folder.files && folder.files.map(file => (
              <div
                key={file.id}
                className="dropdown-item file-item"
                onClick={() => handleFileClick(file, (() => {
                  try {
                    let filename = file.file || file.file_url?.split('/').pop();
                    if (!filename) return file.category;
                    filename = filename.replace(/^\d+_/, '');
                    return filename
                      .replace(/%C3%83%C2%85/g, 'Å')
                      .replace(/%C3%83%C2%84/g, 'Ä')
                      .replace(/%C3%83%C2%96/g, 'Ö')
                      .replace(/%C3%83%C2%A4/g, 'ä')
                      .replace(/%C3%83%C2%A5/g, 'å')
                      .replace(/%C3%83%C2%B6/g, 'ö')
                      .replace(/%C3%A5/g, 'å')
                      .replace(/%C3%A4/g, 'ä')
                      .replace(/%C3%B6/g, 'ö')
                      .replace(/Ã¥/g, 'å')
                      .replace(/Ã¤/g, 'ä')
                      .replace(/Ã¶/g, 'ö')
                      .replace(/Ã…/g, 'Å')
                      .replace(/Ã„/g, 'Ä')
                      .replace(/Ã–/g, 'Ö');
                  } catch (e) {
                    return file.category;
                  }
                })())}
                style={{ 
                  cursor: 'pointer', 
                  fontSize: '0.8em', 
                  color: '#666',
                  paddingLeft: '10px',
                  borderLeft: '2px solid #ddd',
                  backgroundColor: '#fff',
                  border: '1px solid #e9ecef',
                  borderRadius: '2px',
                  margin: '1px 0'
                }}
              >
                📄 {(() => {
                  try {
                    let filename = file.file || file.file_url?.split('/').pop();
                    if (!filename) return file.category;
                    filename = filename.replace(/^\d+_/, '');
                    return filename
                      .replace(/%C3%83%C2%85/g, 'Å')
                      .replace(/%C3%83%C2%84/g, 'Ä')
                      .replace(/%C3%83%C2%96/g, 'Ö')
                      .replace(/%C3%83%C2%A4/g, 'ä')
                      .replace(/%C3%83%C2%A5/g, 'å')
                      .replace(/%C3%83%C2%B6/g, 'ö')
                      .replace(/%C3%A5/g, 'å')
                      .replace(/%C3%A4/g, 'ä')
                      .replace(/%C3%B6/g, 'ö')
                      .replace(/Ã¥/g, 'å')
                      .replace(/Ã¤/g, 'ä')
                      .replace(/Ã¶/g, 'ö')
                      .replace(/Ã…/g, 'Å')
                      .replace(/Ã„/g, 'Ä')
                      .replace(/Ã–/g, 'Ö');
                  } catch (e) {
                    return file.category;
                  }
                })()}
              </div>
            ))}
            
            {/* Recursively render subfolders */}
            {folder.subfolders && folder.subfolders.length > 0 && 
              renderFolderWithSubfolders(folder.subfolders, indentLevel + 15)
            }
            
            {(!folder.files || folder.files.length === 0) && (!folder.subfolders || folder.subfolders.length === 0) && (
              <div className="dropdown-item" style={{ fontSize: '0.8em', color: '#999', fontStyle: 'italic' }}>
                No files or subfolders in this folder
              </div>
            )}
          </div>
        )}
      </div>
    ));
  };

  useEffect(() => {
    const fetchSharedFolders = async () => {
      if (isAuthenticated && user) {
        try {
          const token = await getAccessTokenSilently({
            authorizationParams: {
              audience: process.env.REACT_APP_AUTH0_AUDIENCE,
              scope: 'read:folders',
            },
          });
          
          // Fetch folders with their files
          const response = await api.get('/api/folders', {
            headers: {
              'Authorization': `Bearer ${token}`,
            },
          });
          
          // Filter for shared folders only
          const sharedFoldersData = response.data.folders.filter(folder => folder.allow_shared_access);
          setSharedFolders(sharedFoldersData);
        } catch (error) {
          console.error('Error fetching shared folders:', error);
        }
      }
    };

    fetchSharedFolders();
  }, [isAuthenticated, user, getAccessTokenSilently]);

  // Temporarily disable the user authentication check
  // if (!user) {
  //   return null; // Do not render the dropdown if the user is not authenticated
  // }

  return (
    <React.Fragment>
      <div
        className={`dropdown bottom-right ${isDropdownOpen ? "open" : ""}`}
        onMouseLeave={handleDropdownClose}
      >
        <button
          className="dropdown-toggle btn btn-link"
          onMouseEnter={handleDropdownToggle}
        >
          DOCUMENTS
          <clr-icon shape="arrow" dir="down"></clr-icon>
        </button>
        <div className="dropdown-menu">
          <h4 className="dropdown-header">MÅSTE DATABASE</h4>
          <Link
            to="/public_docs"
            className="dropdown-item"
          >
            Public Documents
          </Link>
          <Link
            to="/deliverables_public"
            className="dropdown-item"
          >
            Deliverables (public ones)
          </Link>
          <div className="dropdown-divider"></div>
          <Link
            to="/search"
            className={`dropdown-item ${!user ? "disabled" : ""}`}
          >
            Search Database
          </Link>
          {renderMenuItemWithSharedFolders("/WP1", "WP1", "wp", "WP1", !user)}
          {renderMenuItemWithSharedFolders("/WP2", "WP2", "wp", "WP2", !user)}
          {renderMenuItemWithSharedFolders("/WP3", "WP3", "wp", "WP3", !user)}
          {renderMenuItemWithSharedFolders("/WP4", "WP4", "wp", "WP4", !user)}
          {renderMenuItemWithSharedFolders("/WP5", "WP5", "wp", "WP5", !user)}
          {renderMenuItemWithSharedFolders("/WP6", "WP6", "wp", "WP6", !user)}
          {renderMenuItemWithSharedFolders("/contactlists", "Contact Lists", "contactlists", null, !user)}
          {renderMenuItemWithSharedFolders("/deliverables", "Deliverables", "deliverables", null, !user)}
          {renderMenuItemWithSharedFolders("/meetings", "Meetings", "meetings", null, !user)}
          {renderMenuItemWithSharedFolders("/promotion", "Promotion materials", "promotion", null, !user)}
          {renderMenuItemWithSharedFolders("/publications", "Publications", "publications", null, !user)}
          {renderMenuItemWithSharedFolders("/reports", "Reports", "reports", null, !user)}
          {renderMenuItemWithSharedFolders("/templates", "Templates", "templates", null, !user)}
          {renderMenuItemWithSharedFolders("/Upload", "Upload", "upload", null, !user)}
          <div className="dropdown-divider"></div>
          <Link
            to="/help"
            className={`dropdown-item ${!user ? "disabled" : ""}`}
            style={{ fontWeight: 'bold', color: '#FF9800' }}
          >
            📖 Help / User Manual
          </Link>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Dropdown_3;